import { utils } from '@sfaas/util';

export default {
	plants_: state => {
		const { plants } = state.selectOptions;
		return plants;
	},

	pgmIds_: state => {
		const { pgmIds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...pgmIds];
	},

	plantCd_: state => {
		const { plantCd } = state.searchParams;
		return plantCd;
	},

	pgmId_: state => {
		const { pgmId } = state.searchParams;
		return pgmId;
	},

	urlSearchParams_: state => {
		const { searchParams, pagingInfo } = state;
		const urlSearchParams = new URLSearchParams();
		Object.keys(searchParams).forEach(key => {
			const value = searchParams[key];
			if (!utils.$sf_isNull(value) && !utils.isUndefined(value) && !value.includes('ALL')) {
				urlSearchParams.set(key, value);
			}
		});
		// TODO
		Object.keys(pagingInfo).forEach(key => {
			const validKeys = ['currentPage', 'pageUnit'];
			const value = pagingInfo[key];
			if (validKeys.includes(key)) {
				urlSearchParams.set(key, value);
			}
		});
		return urlSearchParams.toString();
	},

	totalSize_: state => {
		const { pagingInfo } = state;
		const { totalSize } = pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pagingInfo } = state;
		const { pageUnit } = pagingInfo;
		return pageUnit;
	}
};
